export default function UpdateUserProfileForm() {
    return {
        restrict: "E",
        scope: {
            user: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, $q, Roles, Users, ENV, Log) {
            let roles = null;
            $scope.role = null;
            $scope.debug = false;
            $scope.displayForm = false;
            $scope.models = null;

            $scope.formHolder = {};

            const allowedRolesDEV = [
                { id: 3, name: "Bruger" },
                {
                    id: 4,
                    name: "Virksomhed",
                },
                { id: 15, name: "Forening" },
                { id: 72, name: "KK instutition" },
            ];

            $scope.changeRolesDEV =
                ENV.type == "development" || ENV.type == "staging"
                    ? allowedRolesDEV
                    : null;

            $q.all({
                primaryRole: Roles.get($scope.user.primaryRole),
                roles: Roles.get(),
                userCompany: Users.getCompanyInfo($scope.user.id),
                psp: Users.getPsp($scope.user.id),
            }).then(
                (res) => {
                    roles = res.roles; // also used by DEV feature (change user role)

                    $scope.models = {
                        role: res.primaryRole,
                        user: $scope.user,
                        company: res.userCompany, // nullable
                        psp: res.psp,
                    };

                    $scope.displayForm = true;
                },
                (err) => {
                    console.warn(err);
                }
            );

            $scope.setUserRoleDEV = (roleId) => {
                $scope.models.user.primaryRole = roleId; // TEST
                $scope.models.role = findRole(roleId, roles);
            };

            const findRole = (userPrimaryRole, roles) => {
                /** lookup user role  */
                return roles.find((role) => role.id === userPrimaryRole);
            };

            // When the user submit the formHolder.formUpdateUserProfile
            $scope.updateUser = function (user, company, psp) {
                Users.update(user).then(
                    (res) => {
                        $scope.notification = {
                            status: "success",
                            message: "Brugeren er opdateret.",
                        };

                        Log.string("Update Profile", "User info updated");

                        if (user.primaryRole == 4) {
                            Users.updateCompanyInfo(user.id, company).then(
                                (res) => {
                                    Log.string(
                                        "Update Profile",
                                        "Company info updated"
                                    );
                                }
                            );
                        }

                        if (user.primaryRole == 72) {
                            Users.updatePsp(user.id, psp).then((res) => {
                                Log.string("Update Profile", "PSP updated");
                            });
                        }
                        /**
                         * reset form to pristine state
                         */
                        $scope.formHolder.formUpdateUserProfile.$setPristine(
                            true
                        );
                    },
                    (err) => {
                        $scope.notification = {
                            status: "error",
                            message:
                                "Din bruger blev ikke opdateret, kontakt os venligst.",
                        };
                    }
                );
            };

            /**
             * Return role obj if
             * Shoud be capability based
             */
            $scope.userHasOneOfThesesRoles = (ids, roleId) => {
                return Roles.userHasOneOfThesesRoles(ids, roleId); // return bool
            };
        },
    };
}
